import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const point = document.querySelector('.p-point__section'),
  imgs = document.querySelectorAll('.p-point__img--main__picture');

const calculateStart = (img) => {
  // ビューポート幅に基づいた条件分岐で、異なるstart位置を返す
  const viewportWidth = window.innerWidth;
  if (viewportWidth < 940) {
    // スマホビューポートの場合
    return 'top top+=100px';
  } else if (viewportWidth < 1024) {
    // タブレットビューポートの場合
    return 'top top+=100px';
  } else {
    // デスクトップビューポートの場合
    return 'top center-=339px';
  }
};

const calculateEnd = (point, img, index) => {
  // ビューポート幅に基づいた条件分岐で、異なるstart位置を返す
  const viewportWidth = window.innerWidth;
  if (viewportWidth < 940) {
    // スマホビューポートの場合
    return '+=' + (point.clientHeight - (point.clientHeight / 4));
  } else if (viewportWidth < 1024) {
    // タブレットビューポートの場合
    return '+=' + (point.clientHeight - img.clientHeight);
  } else {
    // デスクトップビューポートの場合
    return '+=' + (point.clientHeight - img.clientHeight);
  }
};

// ビューポートの幅に応じてkeyframesを選択
const getKeyframes = (index) => {
  const viewportWidth = window.innerWidth;

  // 例: モバイルデバイス
  if (viewportWidth < 940) {
    return [
      { '0%': { opacity: 1 }, '6%': { opacity: .3 }, '27%': { opacity: .3 }, '33%': { opacity: 0 } },
      { '30%': { opacity: 0 }, '35%': { opacity: 1 }, '41%': { opacity: .3 }, '60%': { opacity: .3 }, '66%': { opacity: 0 } },
      { '63%': { opacity: 0 }, '68%': { opacity: 1 }, '73%': { opacity: .3 }, '92%': { opacity: .3 }, '98%': { opacity: 0 }, },
      { '95%': { opacity: 0 }, '100%': { opacity: 1 }, }
    ][index];
  }
  // 例: タブレット
  else if (viewportWidth < 1024) {
    return [
      { '0%': { opacity: 1 }, '6%': { opacity: .5 }, '27%': { opacity: .5 }, '33%': { opacity: 0 } },
      { '30%': { opacity: 0 }, '35%': { opacity: 1 }, '41%': { opacity: .5 }, '60%': { opacity: .5 }, '66%': { opacity: 0 } },
      { '63%': { opacity: 0 }, '68%': { opacity: 1 }, '73%': { opacity: .5 }, '92%': { opacity: .5 }, '98%': { opacity: 0 }, },
      { '95%': { opacity: 0 }, '100%': { opacity: 1 }, }
    ][index];
  }
  // デフォルト: デスクトップ
  else {
    return [
      { '0%': { opacity: 1 }, },
      { '30%': { opacity: 0 }, '35%': { opacity: 1 }, },
      { '63%': { opacity: 0 }, '68%': { opacity: 1 }, },
      { '95%': { opacity: 0 }, '100%': { opacity: 1 }, }
    ][index];
  }
};


Array.from(imgs).forEach((img, index) => {

  if (point) {
    let pointTl = gsap.timeline({
      scrollTrigger: {
        scrub: 1,
        trigger: img,
        endTrigger: img,
        start: () => calculateStart(img),
        end: () => calculateEnd(point, img, index),
        pin: true,
        // markers: true,
      }
    })

    const keyframes = getKeyframes(index);

    const key = [
      {
        '0%': { opacity: 1 },
      },
      {
        '30%': { opacity: 0 },
        '35%': { opacity: 1 },
      },
      {
        '63%': { opacity: 0 },
        '68%': { opacity: 1 },
      },
      {
        '95%': { opacity: 0 },
        '100%': { opacity: 1 },
      }
    ]

    pointTl.addLabel('start')
      .to(img, 1, {
        keyframes: keyframes,
      })
  }
});

window.addEventListener('resize', () => {
  ScrollTrigger.refresh();
});